import { ActionTree } from 'vuex'
import { TrailState } from './types'
import { RootState } from '../types'
import { ThingsHelpers, TrailsHelpers } from '@/helpers/mainExports.js'
import dayjs from 'dayjs'

export const actions: ActionTree<TrailState, RootState> = {
  clearThingTrailLocations({ commit }) {
    commit('clearThingTrailLocations')
  },
  emptyTrailLocations({ commit }) {
    commit('emptyTrailLocations')
  },
  async getThingTrailSummary({ commit }, payload = null) {
    try {
      let from = dayjs()
        .startOf('day')
        .valueOf()
      let to = dayjs().valueOf()

      if (!!payload) {
        from = payload.from
        to = payload.to
      }

      const thingTrailSummaryData = await TrailsHelpers.getThingTrailSummary(
        from,
        to
      )

      commit('setThingTrailSummary', { thingTrailSummaryData })
    } catch (err) {
      console.error(err)
      throw new Error('Error al obtener resumen de recorrido')
    }
  },
  async nextRequestNewPageInTrailLocation(
    { commit, dispatch, state },
    payload
  ) {
    payload.page = state.thingPage
    dispatch('getThingTrail', payload)
  },
  getTrailLocation({ commit, getters }, { id, location }) {
    return new Promise((resolve, reject) => {
      const locationStoredFound = getters.getGeofenceLocation.find(
        geoRef => geoRef.id === id
      )
      if (!!locationStoredFound) resolve(locationStoredFound)
      else
        TrailsHelpers.getTrailLocation(location).then(res => {
          const geoReference = res[0]
          Object.assign(geoReference, { id })
          commit('setTrailLocation', { geoReference })
          resolve(geoReference)
        })
    })
  },
  async getThingTrail({ commit, dispatch, state }, payload = null) {
    let trailLocations
    try {
      if (payload !== null) {
        trailLocations = await TrailsHelpers.getTrailLocations(
          payload.from,
          payload.to,
          payload.page
        )
        if (trailLocations.length < 1000) {
          state.thingPage = 1
          commit('setDataLoading', false)
        } else {
          commit('nextPageTrailLocation')
          dispatch('nextRequestNewPageInTrailLocation', payload)
        }
      } else {
        //HOY: desde las 00:00 de hoy a la hora actual. Este es el DEFAULT con que se consulta al ingresar a la pantalla de recorrido.
        const from = dayjs()
          .startOf('day')
          .valueOf()
        const to = dayjs().valueOf()
        trailLocations = await TrailsHelpers.getTrailLocations(from, to)
      }

      if (!Boolean(state.thingGpsID)) {
        const [firstLocation] = trailLocations.slice(0, 1)
        commit('setThingGpsID', { gpsID: firstLocation?.gps_id ?? '' })
      }

      if (!Boolean(state.prevNonNullOdometer)) {
        const firstOdometerNotNull =
          trailLocations.find(loc =>
            Boolean(TrailsHelpers.getOdometerByCase(loc))
          ) ?? {}

        const odometer =
          TrailsHelpers.getOdometerByCase(firstOdometerNotNull) ?? null

        commit('setPrevNonNullOdometer', { odometer })
      }
      // Caso Ingnition status y thing contact on
      if (state.prevNonNullIgnitionStatus == null) {
        const firstSignalWithIgnitionStatusNotNull = trailLocations.find(
          loc => loc.ignition_status != null
        )
        const firstSignalWithThingContactOnNotNull = trailLocations.find(
          loc => loc.thing_contact_on != null
        )

        if (
          !Boolean(firstSignalWithIgnitionStatusNotNull) &&
          !Boolean(firstSignalWithThingContactOnNotNull)
        ) {
          commit('setPrevNonNullMainPowerOn', {
            ignitionStatus: true
          })
        }

        if (
          !Boolean(firstSignalWithIgnitionStatusNotNull) &&
          Boolean(firstSignalWithThingContactOnNotNull)
        ) {
          commit('setPrevNonNullMainPowerOn', {
            ignitionStatus:
              firstSignalWithThingContactOnNotNull.thing_main_power_on
          })
        }

        if (Boolean(firstSignalWithIgnitionStatusNotNull)) {
          commit('setPrevNonNullIgntitionStatus', {
            ignitionStatus: firstSignalWithIgnitionStatusNotNull.ignition_status
          })
        }
      }

      // Caso main power on y thing main power on
      if (state.prevNonNullMainPowerOn == null) {
        const firstSignalWithMainPowerOnNotNull = trailLocations.find(
          loc => loc.main_power_on != null
        )
        const firstSignalWithThingMainPowerOnNotNull = trailLocations.find(
          loc => loc.thing_main_power_on != null
        )

        if (
          !Boolean(firstSignalWithMainPowerOnNotNull) &&
          !Boolean(firstSignalWithThingMainPowerOnNotNull)
        ) {
          commit('setPrevNonNullMainPowerOn', {
            mainPowerOn: true
          })
        }

        if (
          !Boolean(firstSignalWithMainPowerOnNotNull) &&
          Boolean(firstSignalWithThingMainPowerOnNotNull)
        ) {
          commit('setPrevNonNullMainPowerOn', {
            mainPowerOn:
              firstSignalWithThingMainPowerOnNotNull.thing_main_power_on
          })
        }

        if (Boolean(firstSignalWithMainPowerOnNotNull)) {
          commit('setPrevNonNullMainPowerOn', {
            mainPowerOn: firstSignalWithMainPowerOnNotNull.main_power_on
          })
        }
      }

      let arrayTrails = trailLocations.map((item, index) => {
        //Se añade al objeto una propiedad ID que sera reflejada en la tabla como número de orden
        item.id = state.trailLocations.length + index + 1
        item.fuel_cut_off = item.fuel_cut_off ? item.fuel_cut_off : false

        let odometerValue

        if (Boolean(state.prevNonNullOdometer)) {
          odometerValue =
            TrailsHelpers.getOdometerByCase(item) < state.prevNonNullOdometer!
              ? state.prevNonNullOdometer!
              : TrailsHelpers.getOdometerByCase(item)
        } else {
          odometerValue = TrailsHelpers.getOdometerByCase(item)
        }

        if (state.thingGpsID !== item.gps_id) {
          commit('setThingGpsID', { gpsID: item.gps_id })

          commit('setPrevNonNullOdometer', {
            odometer: TrailsHelpers.getOdometerByCase(item)
          })

          item.partialDistance = state.totalDistance

          return item
        } else if (!Boolean(state.prevNonNullOdometer)) {
          if (Boolean(TrailsHelpers.getOdometerByCase(item))) {
            commit('setPrevNonNullOdometer', {
              odometer: TrailsHelpers.getOdometerByCase(item)
            })
          }

          item.partialDistance = state.totalDistance
          return item
        }

        if (!Boolean(TrailsHelpers.getOdometerByCase(item))) {
          item.partialDistance = state.totalDistance
          return item
        }

        commit('setTotalDistance', {
          partialDistance: odometerValue - Number(state.prevNonNullOdometer)
        })

        commit('setPrevNonNullOdometer', {
          odometer: TrailsHelpers.getOdometerByCase(item)
        })

        item.partialDistance = state.totalDistance

        return item
      })

      arrayTrails.forEach(item => {
        if (item.ignition_status == null) {
          item.ignitionStatus = state.prevNonNullIgnitionStatus
        } else {
          item.ignitionStatus = item.ignition_status
          commit('setPrevNonNullIgntitionStatus', {
            ignitionStatus: item.ignition_status
          })
        }
      })

      arrayTrails.forEach(item => {
        if (item.main_power_on == null) {
          item.batteryStatus = state.prevNonNullMainPowerOn
        } else {
          item.batteryStatus = item.main_power_on
          commit('setPrevNonNullMainPowerOn', {
            mainPowerOn: item.main_power_on
          })
        }
      })

      if ('mrn:service:ibutton' in state.thing?.services) {
        arrayTrails.forEach(item => {
          if (
            item.ibutton === '' ||
            item.ibutton === null ||
            item.ibutton === '00000000'
          ) {
            item.driver = {
              column: '-'
            }
            return
          }
          if (item.ibutton === 'EEEEEEEE') {
            item.driver = {
              column: 'Desconocido'
            }
            return
          }
          if (
            !Boolean(item.driver?.first_name) &&
            !Boolean(item.driver?.last_name) &&
            !Boolean(item.driver?.id) &&
            'ibutton' in item
          ) {
            item.driver = {
              column: item.ibutton
            }
            return
          }
          if (!('ibutton' in item)) {
            item.driver = {
              column: '-'
            }
            return
          }
          item.driver.column = `${item.driver.first_name} ${item.driver.last_name}`
        })
      }

      // store last not null candata, ignition_status or main_power_on
      if (!Boolean(state.prevNonNullCandata)) {
        const firstSignalWithCandataNotNull = trailLocations.find(
          loc =>
            Boolean(loc.candata?.fuel_tank) && Boolean(loc.candata?.odoliter)
        )
        if (Boolean(firstSignalWithCandataNotNull)) {
          commit('setPrevNonNullCandata', {
            candata: firstSignalWithCandataNotNull.candata
          })
        } else {
          commit('setThingTrailLocations', arrayTrails)
          const payload1 = { arrayTrails: arrayTrails }
          commit('setTrailLocationByPage', payload1)
          return
        }
      }

      // total fuel consumption and fuel tank calculation
      arrayTrails = arrayTrails.map(item => {
        const { candata } = item

        if (!Boolean(state.prevNonNullCandata)) {
          if (Boolean(candata?.fuel_tank)) {
            commit('setPrevNonNullCandata', { candata })
            item.fuelTank = candata.fuel_tank
          }
          item.partialOdoliter = state.totalOdoliter
          return item
        }

        if (!Boolean(candata?.fuel_tank)) {
          item.partialOdoliter = state.totalOdoliter
          item.fuelTank = state.prevNonNullCandata?.fuel_tank
          return item
        }

        commit('setTotalOdoliter', {
          partialOdoliter:
            candata.odoliter - Number(state.prevNonNullCandata?.odoliter)
        })
        commit('setPrevNonNullCandata', { candata })

        item.partialOdoliter = state.totalOdoliter
        item.fuelTank = state.prevNonNullCandata?.fuel_tank

        return item
      })

      arrayTrails = arrayTrails.map(item => {
        if (
          'fuelTank' in item &&
          ThingsHelpers.getThingStatus(state.thing.type, item) === 'stop'
        )
          item.fuelTank = -1
        return item
      })

      const payload2 = { arrayTrails: arrayTrails }
      commit('setThingTrailLocations', arrayTrails)
      commit('setTrailLocationByPage', payload2)
    } catch (e) {
      console.error(e)
    }
  },
  highlightMarker({ commit }, id) {
    commit('highlightMarker', id)
  },
  setGeoReference({ commit }, payload) {
    commit('setGeoReference', payload)
  },
  setDataLoading({ commit }, value) {
    commit('setDataLoading', value)
  },
  setQueryTimestamp({ commit }, timestamp) {
    commit('setQueryTimestamp', timestamp)
  },
  setThingTrail({ commit }, thing) {
    commit('setThingTrail', thing)
  },
  toggleShowEvents({ commit }, value) {
    commit('toggleShowEvents', value)
  }
}
